import { createSelector } from '@reduxjs/toolkit';
import { initialState } from '../Slice/ClustersSlice';
import { RootState } from '../Store/InjectorsTypes';

const selectDomain = (state: RootState) => state?.clusters || initialState;

export const selectAllClusterLoading = createSelector(
  [selectDomain],
  (state) => state.allClustersLoading,
);

export const selecteActiveClusterLoading = createSelector(
  [selectDomain],
  (state) => state.activeClustersLoading,
);

export const selectActiveClustersLoaded = createSelector(
  [selectDomain],
  (state) => state.activeClustersLoaded,
);


export const selectAllClusters = createSelector(
  [selectDomain],
  (state) => state.allClusters,
);

export const selectClusterCount = createSelector(
  [selectDomain],
  (state) => state.clusterCount,
);

export const selectClusterPageNumber = createSelector(
  [selectDomain],
  (state) => state.clusterPageNumber,
);

export const selectClustersShared = createSelector(
  [selectDomain],
  (state) => state.clustersShared,
);

export const selectSelectedClusters = createSelector(
  [selectDomain],
  (state) => state.selectedClusters,
);

export const selectClusterDrawerOpen = createSelector(
  [selectDomain],
  (state) => state.clusterDrawerOpen,
);

export const selectActiveClusters = createSelector(
  [selectDomain],
  (state) => state.activeClusters,
);

export const selectDetailsLoading = createSelector(
  [selectDomain],
  (state) => state.detailsLoading,
);

export const selectClusterId = createSelector(
  [selectDomain],
  (state) => state.clusterId,
);

export const selectClusterName = createSelector(
  [selectDomain],
  (state) => state.clusterName,
);

export const selectClusterShared = createSelector(
  [selectDomain],
  (state) => state.clusterShared,
);

export const selectAllClusterCompanies = createSelector(
  [selectDomain],
  (state) => state.clusterCompanies,
);

export const selectAllClusterCompanyCount = createSelector(
  [selectDomain],
  (state) => state.clusterCompanyCount,
);

export const selectSharedByFirstName = createSelector(
  [selectDomain],
  (state) => state.sharedByFirstName,
);

export const selectCreationSuccess = createSelector(
  [selectDomain],
  (state) => state.creationSuccess,
);

export const selectAllCompanyDetailsLoading = createSelector(
  [selectDomain],
  (state) => state.allCompanyDetailsLoading,
);

export const selectSelectedClusterCompanies = createSelector(
  [selectDomain],
  (state) => state.selectedClusterCompanies,
);

export const selectClusterCompanyProfile = createSelector(
  [selectDomain],
  (state) => state.companyProfile,
);

export const selectClusterCompanyProfileLoading = createSelector(
  [selectDomain],
  (state) => state.profileLoading,
);

export const selectClusterStocksChart = createSelector(
  [selectDomain],
  (state) => state.stocksData,
);

export const selectClusterStocksChartLoading = createSelector(
  [selectDomain],
  (state) => state.stocksLoading,
);

export const selectClusterStrategicHighlights = createSelector(
  [selectDomain],
  (state) => state.strategicHighlights,
);

export const selectClusterStrategicHighlightsLoading = createSelector(
  [selectDomain],
  (state) => state.strategicHighlightsLoading,
);

export const selectClusterSWOTLoading = createSelector(
  [selectDomain],
  (state) => state.swotLoading,
);

export const selectClusterSWOTData = createSelector(
  [selectDomain],
  (state) => state.swotData,
);

export const selectClusterSwotRefreshedCompany = createSelector(
  [selectDomain],
  (state) => state.swotRefreshedCompany,
);

export const selectClusterRefreshCompanyIds = createSelector(
  [selectDomain],
  (state) => state.refreshCompanyIds,
);

export const selectClusterCompanySecFilings = createSelector(
  [selectDomain],
  (state) => state.companySecFilings,
);

export const selectClusterCompanySecFilingsLoading = createSelector(
  [selectDomain],
  (state) => state.companySecFilingsLoading,
);

export const selectClusterCompanyNewsLoading = createSelector(
  [selectDomain],
  (state) => state.companyNewsLoading,
);

export const selectClusterCompanyPageNumber = createSelector(
  [selectDomain],
  (state) => state.companyNewsPageNumber,
);

export const selectClusterCompanyNewsFilterLoading = createSelector(
  [selectDomain],
  (state) => state.companyNewsFiltersLoading,
);

export const selectClusterCompanyNews = createSelector(
  [selectDomain],
  (state) => state.companyNews,
);

export const selectClusterCompanyNewsEnded = createSelector(
  [selectDomain],
  (state) => state.companyNewsEnded,
);

export const selectClusterCompanyNewsFilter = createSelector(
  [selectDomain],
  (state) => state.companyNewsFilters,
);

export const selectClusterCompanyNewsFilterSelected = createSelector(
  [selectDomain],
  (state) => state.companyNewsFiltersSelected,
);

export const selectClusterCompanyNewsFiltersApplied = createSelector(
  [selectDomain],
  (state) => state.companyNewsFiltersApplied,
);

export const selectClusterCompanyNewsCompanyIdsApplied = createSelector(
  [selectDomain],
  (state) => state.companyNewsCompanyIdsApplied,
);

export const selectClusterNewsFilterApplied = createSelector(
  [selectDomain],
  (state) => state.newsFilterApplied,
);

export const selectClusterProductAndServices = createSelector(
  [selectDomain],
  (state) => state.productAndServices,
);

export const selectClusterProductAndServicesLoading = createSelector(
  [selectDomain],
  (state) => state.productAndServicesLoading,
);
